"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Components = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _styledSystem = require("styled-system");
var _constant = require("../../styles/constant");
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
const ArrowBorder = (0, _styledSystem.variant)({
  prop: 'placement',
  variants: {
    top: {
      borderTop: (0, _constant.get)('space.0'),
      borderLeft: (0, _constant.get)('space.0')
    },
    bottom: {
      borderBottom: (0, _constant.get)('space.0'),
      borderRight: (0, _constant.get)('space.0')
    },
    left: {
      borderBottom: (0, _constant.get)('space.0'),
      borderLeft: (0, _constant.get)('space.0')
    },
    right: {
      borderTop: (0, _constant.get)('space.0'),
      borderRight: (0, _constant.get)('space.0')
    }
  }
});
const variants = {
  ArrowBorder
};
const PopoverContainer = _styledComponents["default"].div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  width: auto;\n  font-size: ", ";\n  line-height: ", ";\n  box-sizing: border-box;\n"])), props => props.fit === 'small' ? (0, _constant.get)('space.14') : (0, _constant.get)('space.16'), props => props.fit === 'small' ? (0, _constant.get)('space.20') : (0, _constant.get)('space.24'));
const PopoverContentWrapper = _styledComponents["default"].div(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  position: absolute;\n  top: ", ";\n  left: ", ";\n  max-width: calc(100vw - 10px);\n  width: max-content;\n  z-index: 99999;\n  display: block;\n  box-shadow: 0px 3px 5px -1px rgb(0 0 0 / 4%), 0px 1px 18px 0px rgb(0 0 0 / 3%),\n    0px 6px 10px 0px rgb(0 0 0 / 3%);\n  border: 1px solid rgb(207, 207, 207);\n  border-radius: 4px;\n"])), props => props.top ? "".concat(props.top, "px") : (0, _constant.get)('space.0'), props => props.left ? "".concat(props.left, "px") : (0, _constant.get)('space.0'));
const PopoverContent = _styledComponents["default"].div(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n  overflow: auto;\n  color: rgb(20, 20, 20);\n  background: rgb(255, 255, 255);\n  border-radius: 4px;\n"])));
const Arrow = _styledComponents["default"].div(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["\n  border: 1px solid rgb(207, 207, 207);\n  background: rgb(255, 255, 255);\n  top: ", ";\n  left: ", ";\n  height: ", ";\n  width: ", ";\n  position: absolute;\n  transform: rotate(45deg);\n  z-index: -1;\n  ", "\n  ", "\n"])), props => props.top ? "".concat(props.top, "px") : 'unset', props => props.left ? "".concat(props.left, "px") : 'unset', props => props.fit === 'small' ? '7px' : props.fit === 'medium' ? '9px' : '11px', props => props.fit === 'small' ? '7px' : props.fit === 'medium' ? '9px' : '11px', variants.ArrowBorder, props => props.staticSide && {
  [props.staticSide]: props.fit === 'small' ? '-3px' : props.fit === 'medium' ? '-4px' : '-5px'
});
const Components = exports.Components = {
  PopoverContainer,
  PopoverContentWrapper,
  PopoverContent,
  Arrow
};